import { useMutation } from '@apollo/client';
import { errorHandler } from 'utils/ErrorHandler';
import { REQUEST_HOST_BUSINESS_INFO_INSPECTION } from '..';

export function useMutationRequestHostBusinessInfoInspection() {
  const [requestHostBusinessInfoInspection, { data }] = useMutation(
    REQUEST_HOST_BUSINESS_INFO_INSPECTION,
  );

  const handleRequestHostBusinessInfoInspection = async (
    hostId: string,
    callback?: () => Promise<void> | void,
  ) => {
    try {
      const response = await requestHostBusinessInfoInspection({
        variables: {
          hostId,
        },
      });

      if (response) {
        await callback?.();
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  return {
    data,
    handleRequestHostBusinessInfoInspection,
  };
}
